import sum from "lodash/sum";

// Password must be true for 3 or more of the following:
const passwordRequirements = [
  // 8 or more chars
  (value: string) => value.length >= 8,
  // Contains upper and lower case chars
  (value: string) => value.match(/([A-Z].*[a-z])|([a-z].*[A-Z])/) !== null,
  // Contains a number
  (value: string) => value.match(/\d/) !== null,
  // Contains at least one non-alpha-numeric character
  (value: string) => value.match(/\W/) !== null,
];

export const passwordValidator = {
  message: () =>
    "Password has to have at least 3 of the following: 8 characters, upper and lower case characters, numbers, one special character.",
  // Returns true if 3 or more requirements are passing
  validate: (value: string) => sum(passwordRequirements.map((validator) => (validator(value) ? 1 : 0))) >= 3,
};
